import { render, staticRenderFns } from "./CollectionActPerformance.vue?vue&type=template&id=49d041c5&scoped=true"
import script from "./CollectionActPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionActPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionActPerformance.vue?vue&type=style&index=0&id=49d041c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d041c5",
  null
  
)

export default component.exports